module.exports = __webpack_public_path__ + "assets/media/card-img-trustworthiness.f9525c0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/card-img-trustworthiness.jpg
// module id = 3253
// module chunks = 0